<template>
    <div class="p-3 text-main-text w-full min-w-full">
        <hts-form-select
            v-if="inputType === 'select'"
            v-model="status"
            :items="items"
            key-id="value"
            key-label="label"
            :size="filterSize"
            :clearable="false"
            @change="updateFilter" />
        <hts-select-option
            v-else
            v-model="status"
            :items="items"
            key-id="value"
            key-label="label"
            :size="filterSize"
            :clearable="false"
            @change="updateFilter" />
    </div>
</template>

<script lang="ts">
export default {
  props: {
    params: Object
  },
  data () {
    return {
      status: null
    }
  },
  computed: {
    inputType () {
      return this.params?.colDef?.filterInputType || 'options'
    },
    items () {
      return this.params?.colDef?.filterItems || []
    },
    filterSize () {
      return this.params?.colDef?.filterSize
    },
    columnField () {
      return this.params?.colDef?.field
    }
  },
  methods: {
    // Tell AG grid filter is changed
    updateFilter () {
      this.params?.filterChangedCallback()
    },
    // Check the filter is using
    doesFilterPass (e: any) {
      if (!this.columnField || typeof this.columnField !== 'string') {
        return false
      }
      return e?.data[this.columnField] !== this.status
    },
    // Check the filter is active
    isFilterActive () {
      return this.status !== null
    },
    // Filter data pass to API
    getModel () {
      if (!this.isFilterActive()) {
        return null
      }

      type filterType =
        | 'equals'
        | 'notEqual'
        | 'greaterThan'
        | 'greaterThanOrEqual'
        | 'lessThan'
        | 'lessThanOrEqual'
        | 'inRange'
        | 'blank'
        | 'notBlank'
        | 'empty'
      const modelDefault = this.params?.colDef?.filterModelDefault || { type: 'contains', filterType: 'text' }
      return { ...modelDefault, ...{ filter: this.status } }
    },
    // Set default filter value
    setModel (model: any) {
      this.status = model == null ? null : model.value
    },
    // Focus when filter is visible if input is text
    afterGuiAttached (e: any) {
      // if (!e || !e.suppressFocus) {
      //   (this.$refs.input as any)?.focus()
      // }
    }
  }
}
</script>
